import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Chip, Tooltip } from '@material-ui/core'
import { FileText as FileTextIcon } from 'react-feather'

import helpers from 'helpers'
import useStyles from './styles'

const FilenameChip = ({ filename, className, maxLabelChars }) => {
  const classes = useStyles()
  if (!filename) return null
  const display = helpers.dai.truncateFilename(filename, maxLabelChars)

  return (
    <Tooltip
      title={filename}
      classes={{ tooltip: classes.tooltip }}
      placement="top"
    >
      <Chip
        size="small"
        icon={<FileTextIcon size={12} />}
        label={display}
        className={clsx(classes.chip, className)}
      />
    </Tooltip>
  )
}

FilenameChip.propTypes = {
  filename: PropTypes.string,
  className: PropTypes.string,
  maxLabelChars: PropTypes.number,
}

FilenameChip.defaultProps = {
  maxLabelChars: 32,
}

export default FilenameChip
